<template>
  <div class="home-container">
    <!-- 欢迎区 -->
    <!-- <div class="header">
      <img :src="logoImg" alt="logo" />
      <span class="title">云赢智能数字化系统</span>
      <span class="link" @click="toPc">数字化PC端</span>
    </div> -->
    <!-- 路由列表区 -->
    <!-- <div class="section-wrap">
      <div class="sec" v-for="item in routerList" :key="item.path" :style="{ backgroundColor: item.meta.bgColor }" @click="to(item)">
        <img :src="item.meta.icon" class="img-icon" />
        <span>{{ item.name }}</span>
      </div>
    </div> -->
    <div>
      <div class="router_type">
        <div class="router_title">待办任务</div>
        <van-row type="flex" justify="center">
          <van-col span="7" class="daiban_flex" @click="toDaiban">
            <img src="../../assets/images/desktop/daiban-home.png" class="img_icon" />
            <div class="daiban_content">
              <div>未处理</div>
              <div :style="count?'color: #ee0a24;':'color: #07c160;'">{{ count }}条</div>
            </div>
          </van-col>
        </van-row>
      </div>
      <span class="link_help" @click="toHelp"><img src="../../assets/images/desktop/help.png" /><div>帮助系统</div></span>
      <span class="link" @click="toPc">数字化PC端<van-icon name="down" size="18" style="margin-left: 8px;transform: rotate(-90deg)" /></span>
      <div v-for="item in routerList" :key="item.path" class="router_type">
        <div class="router_title">{{item.name}}</div>
        <van-row type="flex" justify="space-between">
          <van-col span="5" v-for="val in item.children" :key="val.component" class="flex" @click="to(val)">
            <img :src="val.meta.mobileIcon" class="img_icon" />
            <div class="icon_title">{{val.meta.title}}</div>
          </van-col>
          <van-col span="5"></van-col>
          <van-col span="5"></van-col>
        </van-row>
        <!-- <div v-for="val in item.children" :key="val.component">
          <img :src="val.meta.mobileIcon" />
          <div>{{val.meta.title}}</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getNoGetIncomeCount } from '@/api/admi/user'
import { Cell, Grid, GridItem, NavBar, Image as VanImage, Dialog } from 'vant'
import logoImg from '@/assets/logo.png'
import { getRoutersNew } from '@/api/auth/auth.js'
export default {
  name: 'HomeIndex',
  components: {
    [Cell.name]: Cell,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [GridItem.name]: GridItem,
    [VanImage.name]: VanImage,
    [Dialog.Component.name]: Dialog.Component
  },
  props: {},
  data() {
    return {
      logoImg,
      routerList: []
    }
  },
  computed: {
    ...mapGetters(['oneminute']),
    ...mapGetters(['count'])
  },
  watch: {},
  async mounted() {
    await this.getNoGetIncomeCount()
    this.init()
  },
  methods: {
    ...mapMutations(['user/SET_ONEMINUTE']),
    // 获取用户是否有未认领收款
    async getNoGetIncomeCount() {
      const that = this
      await getNoGetIncomeCount().then(res => {
        if (res.data.incomeCount == 0 && res.data.needCount == 0) { that['user/SET_ONEMINUTE'](0) } else {
          console.log(that.oneminute)
          if (that.oneminute > 0) {
            let minute = that.oneminute
            var time = setInterval(function() { --minute; that['user/SET_ONEMINUTE'](minute); if (minute == 0) { clearInterval(time) } }, 1000)
            Dialog.alert({
              message: `${res.data.incomeCount > 0 ? '当前有未认领的收款数据' + res.data.incomeCount + '条,' : ''}${res.data.needCount > 0 ? '未认领的需求数据' + res.data.needCount + '条,' : ''}请先前往认领！`,
              theme: 'round-button',
              closeOnClickOverlay: true
            }).then(() => {
              if (res.data.incomeCount > 0) {
                that.$router.push({
                  path: '/cont/payment/paymentList',
                  query: {
                    active: 2
                  }
                })
              } else {
                that.$router.push({
                  path: '/channel/management/paymentList',
                  query: {
                    active: 2
                  }
                })
              }
            })
          }
        }
      })
    },
    async init() {
      // 修改主体框架标题
      document.title = '云赢智能数字化系统'

      getRoutersNew().then((res) => {
        this.routerList = res.data
      })
    },
    to(route) {
      if (route.sysType === 2) {
        // window.location.href = route.pathUrl
        window.open(route.component)
      } else {
        this.$router.push({
          path: route.component
        })
      }
      // for (let i = 0; i < this.listData.length; i++) {
      //   const list = this.listData[i]
      //   if (list && list.children && list.children.length > 0) {
      //     const objects = list.children
      //     const newObj = []
      //     for (let y = 0; y < objects.length; y++) {
      //       const obj = objects[y]
      //       if (obj.mobile == 0) {
      //         newObj.push(obj)
      //       }
      //     }
      //     list.children = newObj
      //   }
      // }
    },
    toHelp() {
      // 获取localStorage中的token
      const token = localStorage.getItem('token')
      window.open('http://helpoa.fjyy.com.cn/?token=' + token, '_blank')
    },
    toPc() {
      // 获取localStorage中的token
      const token = localStorage.getItem('token')
      window.open('https://adoa.fjyy.com.cn/?token=' + token, '_blank')
    },
    toDaiban() {
      this.$router.push({
        path: '/daiban'
      })
    }
  }
}
</script>

<style scoped lang="less">
.home-container {
  width: 100%;
  box-sizing: border-box;
  min-height: 100%;
  padding-bottom: 100px;
  .link_help{
    position: absolute;
    right: 20px;
    top: 40px;
    padding: 0px 10px;
    border-radius: 10px;
    color: #666;
    font-size: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width: 60px;
      height: 60px;
    }
  }
  .link{
    position: absolute;
    right: 20px;
    top: 300px;
    padding: 0px 10px;
    line-height: 50px;
    border-radius: 10px;
    background-color: #ee0a24;
    color: #fff;
    font-size: 26px;
  }
  .navigator-box {
    border-radius: 10px;
    border: 1px solid #ccc;
    overflow: hidden;
    margin-bottom: 30px;
    box-shadow: 0px 0px 11px 0px rgba(87, 50, 50, 0.2);
    -webkit-box-shadow: 0px 0px 11px 0px rgba(87, 50, 50, 0.2);
    -moz-box-shadow: 0px 0px 11px 0px rgba(87, 50, 50, 0.2);
    .header-text {
      border-bottom: -0.5rem solid #ccc;
      .van-cell__value {
        span {
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
    .navigator-list {
      background-color: #fff;
      padding: 10px;
      .navigator-item {
        .item-img {
          width: 120px;
          height: 120px;
          overflow: hidden;
        }
        .item-title {
          font-size: 25px;
          margin-top: 20px;
        }
      }
    }
  }
}
.box-container {
  margin: 10px;
  height: auto;
  border-radius: 10px;
}
.icon {
  font-size: 60px;
}

.van-grid-item__content {
  .van-image {
    width: 100px;
    height: 100px;
  }
  span {
    margin-top: 10px;
    font-size: 20px;
  }
}

.van-cell {
  font-size: 15px;
}

.header {
  height: 260px;
  background-color: #0a315d;
  color: #fff;
  font-size: 40px;
  box-sizing: border-box;
  padding: 40px;

  display: flex;
  flex-direction: column;
  position: relative;
  img {
    width: 200px;
    height: 100px;
  }
  .link{
    position: absolute;
    right: 20px;
    top: 10px;
    color: #999;
    font-size: 20px;
  }
}
.section-wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 80px;
  .sec {
    width: 48%;
    height: 260px;
    box-sizing: border-box;
    padding: 40px;
    border-radius: 18px;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // .img-box{
    //   width: 100px;
    //   height: 100px;
    //   .img-icon {
    //     width: 100%;
    //   }
    // }
    .img-icon {
      display: block;
      max-width: 100px;
      // height: 100px;
    }

    span {
      font-size: 30px;
      color: #fff;
    }
  }
}
.router_type{
  background-color: #fff;
  margin-top: 30px;
  padding: 40px 20px;
  .router_title{
    font-weight: 400;
    font-size: 32px;
    color: #333;
    margin-bottom: 30px;
  }
  .flex{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .img_icon{
    width: 100px;
    height: 100px;
  }
  .icon_title{
    margin: 30px 0;
    font-weight: 400;
    color: #333;
    font-size: 24px;
  }
}

.daiban_flex{
  display: flex;
  align-items: center;
  .daiban_content{
    font-size: 26px;
    color: #999;
    line-height: 50px;
  }
}
</style>
